/**
 * WHERE THE API IS. The only file that reads import.meta.env.
 *
 * VITE_API_BASE_URL unset is a state, not an error: requests go to the same
 * origin, which is what a deployment behind one nginx does. It is read on each
 * call rather than once, so a test can stub it.
 *
 * VITE_API_MODE=mock starts the MSW worker and answers every request from
 * src/api/msw. Only "mock" means mock; anything else talks to the server.
 */

export function apiBaseUrl(): string {
  return (import.meta.env.VITE_API_BASE_URL ?? "").trim().replace(/\/+$/, "");
}

export function apiMode(): "mock" | "live" {
  return import.meta.env.VITE_API_MODE === "mock" ? "mock" : "live";
}

/**
 * WHETHER THE DEVELOPER'S OWN PAGES ANSWER — `/_kit` and anything like it.
 *
 * A preview page carries sample values and explains the kit to whoever is
 * building it. At a pharmacy it is a page somebody eventually finds, reads as
 * the product, and reports; so in a build that talks to a real server it is not
 * a route at all.
 *
 * A MOCK BUILD KEEPS IT, which is what the browser gate needs: the fit audit
 * runs against a PRODUCTION build served with `VITE_API_MODE=mock`, and that
 * page is what it measures. Nothing answering a real API answers here.
 */
export function previewRoutesOn(): boolean {
  return import.meta.env.DEV || apiMode() === "mock";
}

/** Joins the base URL and a path. A missing leading slash is added, never guessed around. */
export function apiUrl(path: string): string {
  return `${apiBaseUrl()}${path.startsWith("/") ? path : `/${path}`}`;
}

export const API_PREFIX = "/api/v1";
